export const setLogLevel = ({ commit }, level) => {
  commit('SET_LOG_LEVEL', level);
};

export const toggleShowResponses = ({ commit }) => {
  commit('TOGGLE_SHOW_RESPONSES');
};

export const toggleShowRequests = ({ commit }) => {
  commit('TOGGLE_SHOW_REQUESTS');
};
export const toggleShowPermissions = ({ commit }) => {
  commit('TOGGLE_SHOW_PERMISSIONS');
};
export const toggleDebugApi = ({ commit }) => {
  commit('TOGGLE_DEBUG_API');
};
export const toggleDeveloperMode = ({ commit }) => {
  commit('TOGGLE_DEVELOPER_MODE');
};

export const setShowResponses = ({ commit }, payload) => {
  commit('SET_SHOW_RESPONSES', payload);
};

export const setShowRequests = ({ commit }, payload) => {
  commit('SET_SHOW_REQUESTS', payload);
};
export const setShowPermissions = ({ commit }, payload) => {
  commit('SET_SHOW_PERMISSIONS', payload);
};
export const setDebugApi = ({ commit }, payload) => {
  commit('SET_DEBUG_API', payload);
};
export const setDeveloperMode = ({ commit }, payload) => {
  commit('SET_DEVELOPER_MODE', payload);
};
